function ScanLogo() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#22c55e"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="drop-shadow-[0_0_6px_#22c55e]"
    >
      {/* Top Paper */}
      <rect x="7" y="-8" width="10" height="6" rx="1.2">
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0 0; 0 12; 0 12; 0 0"
          keyTimes="0;0.4;0.6;1"
          dur="3s"
          repeatCount="indefinite"
        />
      </rect>

      {/* Printer */}
      <rect x="6" y="4" width="12" height="4" rx="1.2" />
      <rect x="4" y="8" width="16" height="8" rx="2" />

      {/* Bottom Paper */}
      <rect x="7" y="16" width="10" height="6" rx="1">
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0 -8; 0 -8; 0 4; 0 -8"
          keyTimes="0;0.4;0.8;1"
          dur="3s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
}

export default ScanLogo;